import { createSlice } from "@reduxjs/toolkit";
import VwIstempaneltanimDTO from "src/models/GenelTanimlar/VwIstemPanelTanimDTO";
import VwIstemPanelTanimTarifeDTO from "src/models/GenelTanimlar/VwIstemPanelTanimTarifeDTO";
import VwTestDetaybilgiDTO from "src/models/GenelTanimlar/VwTestDetaybilgiDTO";
import TestIstemdetaybilgiDTO from "src/models/HastaKayit/TestIstemdetaybilgiDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { IstemPanelTanimApi } from "src/services/geneltanimlar/IstemPanelTanimApi";
import { RootState } from "src/store";

export class IstemDetayRequest extends VwTestDetaybilgiDTO {
    deger: string;
}

export interface IIstemPanelTanimModel {
    formOpen: boolean;
    addForm: boolean;
    istemPanelRecord: VwIstempaneltanimDTO;
    istemSecilenList: Array<VwIstempaneltanimDTO>;    
}

const IstemPanelTanimSlice = createSlice<IIstemPanelTanimModel, MapReducerPayloads<IIstemPanelTanimModel, {
    setState: IIstemPanelTanimModel,
    setFormOpen: boolean,
    setAddForm: boolean,
    setIstemPanelRecord: VwIstempaneltanimDTO;
    setIstemSecilenList?: Array<VwIstempaneltanimDTO>;    
}>>({
    name: 'IstemPanel',
    initialState: {
        formOpen: false,
        addForm: false,
        istemSecilenList: [],
        istemPanelRecord: new VwIstempaneltanimDTO()
    },
    reducers: {
        setState: (state, action) => action.payload,
        setFormOpen: (state, action) => {
            state.formOpen = action.payload
        },
        setAddForm: (state, action) => {
            state.addForm = action.payload
        },
        setIstemSecilenList: (state, action) => {
            state.istemSecilenList = action.payload
        },
        setIstemPanelRecord: (state, action) => {
            state.istemPanelRecord = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addMatcher(IstemPanelTanimApi.endpoints.IstemPanelIslemGetir.matchFulfilled, (state, action) => {
          state.istemSecilenList = action.payload
        })
    }
})

export default IstemPanelTanimSlice;
